<template>
  <div class="analytics-wrapper">
    <div class="analytics-wrapper__title">
      {{props.title}}
    </div>
    <div class="analytics-wrapper__description">
      <div>{{description[0]}}</div>
      <div>{{description[1]}}</div>
    </div>
    <VDivider :style="{marginBottom: props.paddingDivider, marginTop: '20px'}"/>
    <div  v-if="items?.length > 0" class="analytics-wrapper__content" :style="{maxHeight: props.height + 'px'}">
      <div :style="{marginTop: props.itemMarginTop}" class="analytics-wrapper__item" v-for="(item, index) in items" >
        <slot :item="item" />
        <VDivider :style="{marginBottom: props.paddingDivider, marginTop: props.itemMarginBottom}" v-if="items?.length !== index + 1"/>
      </div>
    </div>
    <div class="no-data" v-else>
      Нет данных
    </div>
  </div>
</template>
<script setup>
import VDivider from "@/components/UI/VDivider/index.vue";

const props = defineProps({
  items: [Object, Array],
  title: String,
  description: Array,
  paddingDivider: String,
  height: [Number, String],
  itemMarginTop: {
    type: [Number, String],
    default: '16px',
  },

  itemMarginBottom: {
    type: [Number, String],
    default: '',
  },
})
</script>
<style lang="scss" scoped>
.analytics-wrapper {
  padding-top: 24px;
  padding-bottom: 11px;
  background-color: white;
  border-radius: 16px;
  overflow-y: auto;
  max-height: 441px;

  &__content {
    overflow-y: auto;
    scrollbar-width: thin;
  }

  &__title {
    color: $grey-text;
    padding: 0 24px;
    font-size: 20px;
    margin-bottom: 8px;
    font-weight: 600;
  }

  &__description {
    display: flex;
    padding: 0 24px;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 20px;
    color: $dark-blue!important;
    font-weight: 400;
  }

  &__item {
    position: relative;
  }

  .no-data {
    height: 288px;
    width: 100%;
    color: $gray;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 20px;
    text-align: center;
  }
}
</style>